import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ToastController} from 'ionic-angular';
import {AngularFireAuth} from 'angularfire2/auth';
import {environment} from '../../environments/environment';

const {version: appVersion} = require('../../../package.json');

/**
 * Generated class for the LoginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
    selector: 'page-login',
    templateUrl: 'login.html',

})
export class LoginPage {
    public version: string = appVersion;
    public env: string = environment.name;

    logoClickCount = 0;

    loginData = {
        email: '',
        password: ''
    };

    testLogin = !environment.production; // only for development purpose

    authErrorMap = new Map<string, string>();

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                private afAuth: AngularFireAuth,
                private toastCtrl: ToastController) {

        //this.authErrorMap = new Map([["", 'foo'], ["", 'bar']]);
        this.authErrorMap.set("auth/invalid-email", "Die E-Mail-Adresse ist schlecht formatiert."); //The email address is badly formatted.
        this.authErrorMap.set("auth/user-not-found", "Es gibt keinen Benutzerdatensatz, der dieser Kennung entspricht. Der Benutzer wurde möglicherweise gelöscht."); //There is no user record corresponding to this identifier. The user may have been deleted.
        this.authErrorMap.set("auth/wrong-password", "Das Passwort ist ungültig oder der Benutzer hat kein Passwort."); //The password is invalid or the user does not have a password.
        this.authErrorMap.set("auth/invalid-user-token", "Der Berechtigungsnachweis des Benutzers ist nicht mehr gültig. Der Benutzer muss sich erneut anmelden."); //The user's credential is no longer valid. The user must sign in again.
        this.authErrorMap.set("auth/internal-error", "Ein interner Fehler ist aufgetreten."); //An internal error has occurred.
        this.authErrorMap.set("auth/invalid-auth-event", "Ein interner Fehler ist aufgetreten."); //An internal error has occurred.
        this.authErrorMap.set("auth/no-auth-event", "Ein interner Fehler ist aufgetreten."); //An internal error has occurred.
        this.authErrorMap.set("auth/user-disabled", "Das Benutzerkonto wurde von einem Administrator deaktiviert."); //The user account has been disabled by an administrator.
        this.authErrorMap.set("auth/too-many-requests", "Wir haben alle Anfragen von diesem Gerät aufgrund ungewöhnlicher Aktivitäten blockiert. Versuchen Sie es später noch einmal."); //We have blocked all requests from this device due to unusual activity. Try again later.
        this.authErrorMap.set("auth/network-request-failed", "Es kann zur Zeit keine Internetverbindung hergestellt werden.");
    }

    login() {
        // Login Code here
        this.afAuth.auth.signInWithEmailAndPassword(this.loginData.email, this.loginData.password)
            .then(auth => {
                if (!auth.emailVerified) {
                    this.toastCtrl.create({
                        message: "Bitte verifiziere deine E-Mail-Adresse!",
                        duration: 3000,
                        position: "top"
                    }).present();

                } else {
                    this.toastCtrl.create({
                        message: "Willkommen mein Freund!",
                        duration: 3000,
                        position: "top"
                    }).present();
                }
            })
            .catch((err: firebase.FirebaseError) => {
                let preparedMsg = this.authErrorMap.get(err.code);
                if (!preparedMsg) {
                    preparedMsg = err.message;
                }
                this.toastCtrl.create({
                    //message: err.code + "__=__" + err.name + "::" + err.message,
                    message: preparedMsg,
                    duration: 3000,
                    position: "top"
                }).present();
            });
    }

    getLocalizedErrorMsg(code) {

    }


    loginTest(email, pw) {
        this.loginData.email = email;
        this.loginData.password = pw;
        this.login();
    }

    navigateToSignupPage() {
        this.navCtrl.push('SignUpPage', {email: this.loginData.email});
    }

    sendPasswordResetMail() {
        if (!this.loginData.email) {
            this.toastCtrl.create(
                {
                    message: "Bitte Emailadresse angeben",
                    duration: 3000,
                    position: "top"
                }
            ).present();

        } else {
            this.afAuth.auth.sendPasswordResetEmail(this.loginData.email).then(() => {
                this.toastCtrl.create(
                    {
                        message: "E-Mail versendet",
                        duration: 3000,
                        position: "top"
                    }
                ).present();
            });
        }
    }

    logoClick() {
        this.logoClickCount++;
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts